import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { toast } from 'react-toastify';
import { browserHistory } from 'react-router';
import { DataTableSkeleton, Modal, Loading } from 'carbon-components-react';
import { Breadcrumb, Tabs } from '../../../../../components';
import { getByDmService, pathDmService } from '../../../../../services/Api';
import { getStatusUniformIndex } from '../../../../../utils/modifiers';

import {
  PENDENTE,
  PREPARACAO,
  PRONTAENTREGA,
  ENTREGUE,
  CANCELADO,
  namesStatus
} from '../../../../../config/StatusRequest';
import Items from './Items';


class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      isLoading: true,
      isUpdating: false,
      openMdStatus: false,
      cancelModal: false,
      statusIndex: 0,
    };
  }

  componentDidMount() {
    const user = JSON.parse(localStorage.getItem('user'));
    const nivel = (user.nivel || {}).id;
    this.setState({ nivel });

    this.getItems();
  }

  getItems = async () => {
    const { match } = this.props;

    try {
      const data = await getByDmService('/Pedido/GetAssistente', match.params.id);
      const orderStatus = data && data.status;
      const statusIndex = getStatusUniformIndex(orderStatus ? orderStatus.id : {});
      this.setState({ data, isLoading: false, statusIndex });
    } catch (e) {
      toast.error('Ocorreu um erro ao carregar a campanha');
      this.setState({ data: null /* , error: e */, isLoading: false });
    }
  };

  toggleUpdateModal = () => {
    this.setState(prevState => ({ openMdStatus: !prevState.openMdStatus }));
  };

  toogleCancelModal = () => {
    this.setState(prevState => ({ cancelModal: !prevState.cancelModal }));
  };

  buttonRenderRight() {
    const { data, statusIndex, nivel } = this.state;
    return (
      <div>
        {nivel === 10 && statusIndex <= 1 &&
          data.status.id !== 5 && (
            <button
              className="bx--btn btn-primary-outlined h-sm-margin"
              onClick={this.toogleCancelModal}
              type="submit"
            >
              Cancelar Pedido
            </button>
          )}
        {nivel === 10 && statusIndex <= 3 &&
          data.status.id !== 5 && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              onClick={this.toggleUpdateModal}
              type="submit"
            >
              {this.nameButtonStatus(data.status.id)}
            </button>
          )}
        {data.status.id === 5 && <h3 className="text-warning">Pedido Cancelado</h3>}
      </div>
    );
  }

  cancelRequest = () => {
    const { match } = this.props;
    const { id } = match.params;
    const serviceUrl = `/Pedido/AtualizaStatus/${id}?status=${CANCELADO.id}&retirouUniforme=&dataRetiradaUniforme=`;
    this.updateStatus(serviceUrl, 5);
  };

  updateOrderStatus = async () => {
    const { data } = this.state;
    const { match } = this.props;
    const { id } = match.params;
    const arrStatus = [PENDENTE.id, PREPARACAO.id, PRONTAENTREGA.id, ENTREGUE.id, CANCELADO.id];

    const index = arrStatus.indexOf(data.status.id) + 1;
    const serviceUrl = `/Pedido/AtualizaStatus/${id}?status=${arrStatus[index]}&retirouUniforme=&dataRetiradaUniforme=`;
    this.updateStatus(serviceUrl, index);
  };

  updateStatus = (serviceUrl, indexMsg) => {
    const messages = [
      'Status alterado para Pendente',
      'Status alterado para Preparação',
      'Status alterado para Pronto para Entrega',
      'Status alterado para Entregue',
      'Status alterado para Cancelado',
      'Pedido Cancelado conforme o solicitado.',
    ];

    this.setState({ statusIndex: indexMsg });
    pathDmService(serviceUrl, {})
      .then(() => {
        toast.success(messages[indexMsg]);

        if (indexMsg <= 4) {
          this.toggleUpdateModal();
          window.location.href = window.location.href;
        } else {
          this.toogleCancelModal();
        }
      })
      .catch(() => {
        toast.warn('Um erro inesperado ocorreu ao tentar modificar o status');
        this.toggleUpdateModal();
      });
  };

  changeTab = ({ index }) => {
    const { match, history } = this.props;
    const route = index === 0 ? 'detalhe' : 'informacoes';
    history.push(`${match.url}/${route}`);
  };

  nameButtonStatus = status => {
    if (status === PENDENTE.id) {
      return PREPARACAO.value;
    }
    if (status === PREPARACAO.id) {
      return PRONTAENTREGA.value;
    }
    if (status === PRONTAENTREGA.id) {
      return ENTREGUE.value;
    }
    if (status === ENTREGUE.id) {
      return CANCELADO.value;
    }
    return false;
  };



  goUrlList = () => {
    browserHistory.goBack();
  };

  render() {
    const { data, isLoading, isUpdating, openMdStatus, cancelModal } = this.state;
    const { match } = this.props;

    if (isLoading) {
      return (
        <div>
          <Breadcrumb title="---- - ----" description="----" />
          <section className="content-wrapper content-wrapper--large">
            <DataTableSkeleton />
          </section>
        </div>
      );
    }

    return (
      <div>
        {data && (
          <div>
            <Breadcrumb
              title={`Pedido ${data.numero}`}
              description={`Solicitado em ${data.dataSolicitacaoFormata} por ${data.solicitante.nome
                }`}
              renderRight={this.buttonRenderRight()}
              renderLeft={(() => (
                <div className="breadcrumb-left-actions pointer" onClick={() => this.goUrlList()}>
                  <svg width="16" height="14" viewBox="0 0 16 14">
                    <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                  </svg>
                </div>
              ))()}
            />
            <section className="content-wrapper">
              <Tabs
                sections={[
                  { title: 'Todos', path: `${match.url}/todos` },
                  { title: 'Pendente', path: `${match.url}/pendentes` },
                  { title: 'Preparação', path: `${match.url}/preparacao` },
                  { title: 'Pronto p/ Entrega', path: `${match.url}/prontos` },
                  { title: 'Entregue', path: `${match.url}/entregue` },
                  { title: 'Cancelado', path: `${match.url}/cancelado` },
                ]}
              />
              <div className="table-uniforms">
                <Route
                  path={`${match.url}/todos`}
                  component={props => (
                    <Items
                      {...props}
                      itemid={match.params.id}
                      defaultFilters="pendente=&preparacao=&prontoEntrega=&entregue=&cancelados="
                    />
                  )}
                />
                <Route
                  path={`${match.url}/pendentes`}
                  component={props => (
                    <Items
                      {...props}
                      itemid={match.params.id}
                      defaultFilters="pendente=true&preparacao=&prontoEntrega=&entregue=&cancelados="
                    />
                  )}
                />
                <Route
                  path={`${match.url}/preparacao`}
                  component={props => (
                    <Items
                      {...props}
                      itemid={match.params.id}
                      defaultFilters="pendente=&preparacao=true&prontoEntrega=&entregue=&cancelados="
                    />
                  )}
                />
                <Route
                  path={`${match.url}/prontos`}
                  component={props => (
                    <Items
                      {...props}
                      itemid={match.params.id}
                      defaultFilters="pendente=&preparacao=&prontoEntrega=true&entregue=&cancelados="
                    />
                  )}
                />
                <Route
                  path={`${match.url}/entregue`}
                  component={props => (
                    <Items
                      {...props}
                      itemid={match.params.id}
                      defaultFilters="pendente=&preparacao=&prontoEntrega=&entregue=true&cancelados="
                    />
                  )}
                />
                <Route
                  path={`${match.url}/cancelado`}
                  component={props => (
                    <Items
                      {...props}
                      itemid={match.params.id}
                      defaultFilters="pendente=&preparacao=&prontoEntrega=&entregue=&cancelados=true"
                    />
                  )}
                />

                <Modal
                  open={openMdStatus}
                  onRequestSubmit={this.updateOrderStatus}
                  onRequestClose={this.toggleUpdateModal}
                  modalHeading="Modificar Status"
                  primaryButtonText="Tenho certeza"
                  secondaryButtonText="Cancelar"
                >
                  <div>
                    <p>
                      Você tem certeza que deseja alterar o status do pedido
                      <strong>
                        {` ${data.numero} `}
                      </strong>
                      de
                      {' '}
                      <strong>
                        {' '}
                        {namesStatus(data.status.id)}
                        {' '}
                      </strong>
                      {' '}
                      para
                      {' '}
                      <strong>
                        {' '}
                        {this.nameButtonStatus(data.status.id)}
                        {' '}
                      </strong>
                      ?
                    </p>
                  </div>
                </Modal>

                <Modal
                  open={cancelModal}
                  onRequestSubmit={this.cancelRequest}
                  onRequestClose={this.toogleCancelModal}
                  modalHeading="Cancelar Pedido"
                  primaryButtonText="Tenho certeza"
                  secondaryButtonText="Cancelar"
                >
                  <div className="warning-modal-txt">
                    <p>Você tem certeza que deseja cancelar este pedido?</p>
                  </div>
                </Modal>

                {isUpdating && <Loading small />}
              </div>
            </section>
          </div>
        )}
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Gifts/Detail/Main.js